(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/notifications.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/notifications.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useEffect,
  useState,
  useRef
} = React;
const {
  Form
} = svs.ui.reactForm;
const {
  CheckboxItem,
  TopHeader
} = svs.myProfile.react.shared.components;
const {
  trackListChanges
} = svs.myProfile.react.shared.tracking;
const {
  showCustomersOldLinkError,
  showSettingsTechnicalError
} = svs.myProfile.react.shared.dialogs;
const {
  clearAllUrlParam,
  makeSetting
} = svs.myProfile.react.shared.helpers;
const {
  syndicateMailId
} = svs.myProfile.constants;
const {
  useCustomerSettings
} = svs.myProfile.react.shared.hooks;
const {
  putCustomersSettingsAsync
} = svs.myProfile.react.shared.customerSettingsService;
const {
  setPlayerSettingsData
} = svs.myProfile.react.store.pd.actions;
const {
  backendName,
  titles,
  icons
} = svs.myProfile.constants;
const {
  notificationsSyndicateService,
  NotificationsSkeleton
} = svs.myProfile.react.pages.notifications;
const {
  AppNotifications
} = svs.myProfile.react.pages.notifications.appNotifications;
const {
  useSyndicate
} = svs.myProfile.react.pages.notifications.hooks;
const {
  CheckboxSyndicateItem,
  Section
} = svs.myProfile.react.pages.notifications.components;

const Notifications = () => {
  const dispatch = ReactRedux.useDispatch();
  const cAndI = ReactRedux.useSelector(state => state.playerDetails.cAndI);
  const {
    playerSettings
  } = ReactRedux.useSelector(state => state.playerDetails);
  const [hasApiErrorShowed, sethasApiErrorShowed] = useState(false);
  const [playerSyndicateData, setPlayerSyndicateData] = useState();
  const [shouldShowApiError, setShouldShowApiError] = useState(false);
  const [isPlayerLoggedIn] = useState(svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER));
  const syndicateDebounceRef = useRef(null);
  const pendingSyndicateRef = useRef([]);
  const clickedSyndicatesRef = useRef([]);
  useSyndicate(setPlayerSyndicateData, setShouldShowApiError);
  useCustomerSettings(setShouldShowApiError);
  useEffect(() => {
    if (shouldShowApiError && !hasApiErrorShowed) {
      sethasApiErrorShowed(true);
      showSettingsTechnicalError();
    }
  }, [shouldShowApiError, hasApiErrorShowed]);
  useEffect(() => {
    const getData = async () => {
      var _svs$my_profile_react, _svs$my_profile_react2;
      svs.myProfile.logger.debug("**** Player isPlayerLoggedIn: ".concat(isPlayerLoggedIn ? 'Yes' : 'No'));
      const unInLoggedData = (_svs$my_profile_react = svs.my_profile_react.data) === null || _svs$my_profile_react === void 0 ? void 0 : _svs$my_profile_react.communication_settings_react;
      const unInLoggedNotifications = (_svs$my_profile_react2 = svs.my_profile_react.data) === null || _svs$my_profile_react2 === void 0 ? void 0 : _svs$my_profile_react2.notification_settings_react;
      svs.myProfile.logger.debug('get svs.myProfile.data?.communication_settings_react:');
      if (unInLoggedData && unInLoggedData.dataError) {
        clearAllUrlParam();
        showCustomersOldLinkError();
      }
      if (unInLoggedData && unInLoggedData.data) {
        dispatch(setPlayerSettingsData(unInLoggedData));
        dispatch(setPlayerSyndicateData(unInLoggedNotifications.data.notificationSettings));
      }
    };
    getData();
  }, [isPlayerLoggedIn]);
  const handleCheckbox = async (id, isOverride, isEnabledOverride) => {
    svs.myProfile.logger.debug("**** main handleOnChange id: ".concat(id));
    let isEnabled = !playerSettings[id];
    if (isOverride) {
      isEnabled = isEnabledOverride;
    }
    const newPlayerSettingsData = _objectSpread(_objectSpread({}, playerSettings), {}, {
      [id]: isEnabled
    });
    try {
      let res;
      if (isPlayerLoggedIn) {
        res = await putCustomersSettingsAsync([makeSetting(id, !playerSettings[id])]);
      } else {
        const {
          c,
          i
        } = cAndI;
        res = await putCustomersSettingsAsync([makeSetting(id, !playerSettings[id])], c, i);
      }
      const {
        status,
        error
      } = res;
      if (error || status !== 'success') {
        svs.myProfile.logger.debug("**** handleOnChange id: ".concat(id, " error or status not success"), error);
        await showSettingsTechnicalError();
      } else {
        trackListChanges(newPlayerSettingsData, playerSettings, 'notifications', titles.CORRECT);
        dispatch(setPlayerSettingsData(newPlayerSettingsData));
      }
    } catch (error) {
      svs.myProfile.logger.debug("**** handleOnChange id: ".concat(id, " error"), error);
      await showSettingsTechnicalError();
    }
  };
  const handleSyndicateCbx = async id => {
    svs.myProfile.logger.debug("**** main handleSyndicateCbx id: ".concat(id));
    const notification = playerSyndicateData.find(item => item.notificationType === id);
    const checked = notification.transports.find(item => item.transportType === 'Mail');
    const mailNotification = notification.transports.findIndex(item => item.transportType === 'Mail');
    const transportType = {
      enabled: !checked.enabled,
      transportType: 'Mail'
    };
    const transportArray = notification.transports.slice();
    transportArray[mailNotification] = transportType;
    const newNotification = _objectSpread(_objectSpread({}, notification), {}, {
      transports: transportArray
    });
    clickedSyndicatesRef.current.push(newNotification);
    const notificationIndex = playerSyndicateData.findIndex(_ref => {
      let {
        notificationType
      } = _ref;
      return notificationType === notification.notificationType;
    });
    const newPlayerSyndicateData = playerSyndicateData.slice();
    newPlayerSyndicateData[notificationIndex] = newNotification;
    pendingSyndicateRef.current = [...newPlayerSyndicateData];
    setPlayerSyndicateData(newPlayerSyndicateData);
    if (syndicateDebounceRef.current) {
      clearTimeout(syndicateDebounceRef.current);
    }
    const sendData = async () => {
      try {
        let res;
        if (isPlayerLoggedIn) {
          res = await notificationsSyndicateService.putCustomersSyndicateAsync(pendingSyndicateRef.current);
        } else {
          const {
            c,
            i
          } = cAndI;
          res = await notificationsSyndicateService.putCustomersSyndicateAsync(pendingSyndicateRef.current, c, i);
        }
        const {
          status,
          error
        } = res;
        if (error || status !== 'success') {
          svs.myProfile.logger.debug('handleSyndicateCbx: error: ', error);
          showSettingsTechnicalError();
        } else {
          svs.myProfile.logger.debug("handleSyndicateCbx: success :)");
          trackListChanges(clickedSyndicatesRef.current, playerSyndicateData, 'syndicate', titles.PLAYTOGETHER);
          pendingSyndicateRef.current = [];
          clickedSyndicatesRef.current = [];
        }
      } catch (error) {
        showSettingsTechnicalError();
        svs.myProfile.logger.debug('handleSyndicateCbx: catch: error: ', error);
      }
    };
    if (pendingSyndicateRef.current.length > 0) {
      syndicateDebounceRef.current = setTimeout(sendData, 1000);
    }
  };
  useEffect(() => {
    const handleUnload = async () => {
      clearTimeout(syndicateDebounceRef.current);
      if (pendingSyndicateRef.current.length > 0) {
        if (isPlayerLoggedIn) {
          await notificationsSyndicateService.putCustomersSyndicateAsync(pendingSyndicateRef.current);
        } else {
          const {
            c,
            i
          } = cAndI;
          await notificationsSyndicateService.putCustomersSyndicateAsync(pendingSyndicateRef.current, c, i);
        }
      }
    };
    window.addEventListener('unload', handleUnload);
    return () => {
      window.removeEventListener('unload', handleUnload);
    };
  }, []);
  return React.createElement("div", {
    className: "margin-bottom-4"
  }, React.createElement(Form, null, !playerSettings && React.createElement(NotificationsSkeleton, null), playerSettings && React.createElement(React.Fragment, null, React.createElement(TopHeader, {
    icon: icons.CORRECT,
    title: titles.CORRECT
  }), React.createElement("p", null, "Vi kan skicka vinnarmeddelande n\xE4r du vinner och p\xE5minnelser om du spelar flerveckorsspel. G\xE4ller inte f\xF6r Oddset och \xE4r en spelpaus aktiv skickas ingen kommunikation ut."), React.createElement("div", null, React.createElement(CheckboxItem, {
    id: backendName.WIN_RESULTS,
    model: playerSettings,
    onChange: handleCheckbox,
    title: "Skicka e-post efter avgjort spel om du vunnit."
  }), React.createElement(CheckboxItem, {
    id: backendName.RECURRING_WAGER_REMINDERS,
    model: playerSettings,
    onChange: handleCheckbox,
    title: "P\xE5minnelsemejl n\xE4r dina flerveckorsspel beh\xF6ver f\xF6rl\xE4ngas"
  }))), isPlayerLoggedIn && React.createElement(AppNotifications, null), React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(TopHeader, {
    icon: icons.PLAYTOGETHER,
    title: titles.PLAYTOGETHER
  }), React.createElement("p", null, "Du f\xE5r alltid meddelande om n\xE5got av lagen du \xE4r medlem i avslutas, om din roll \xE4ndras eller om Svenska Spel st\xE4ller in en spelomg\xE5ng."), playerSyndicateData && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.DRAW_CREATED,
    onChange: handleSyndicateCbx,
    playerSyndicateData: playerSyndicateData,
    title: "Nytt spel \xF6ppnas upp"
  })), React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-top"
  }, React.createElement(Section, {
    className: "padding-bottom",
    title: "Spel du har andel i"
  }, React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.WAGER_CREATED,
    onChange: handleSyndicateCbx,
    playerSyndicateData: playerSyndicateData,
    title: "Spel l\xE4mnas in"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.TERMINATED,
    onChange: handleSyndicateCbx,
    playerSyndicateData: playerSyndicateData,
    title: "Spel annulleras"
  })), React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.REFUNDED,
    onChange: handleSyndicateCbx,
    playerSyndicateData: playerSyndicateData,
    title: "Spel \xE5terbetalas"
  }))), React.createElement("div", {
    className: "padding-top"
  }, React.createElement(Section, {
    title: "F\xF6r dig som lagkapten"
  }, React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.MEMBER_ADDED,
    onChange: handleSyndicateCbx,
    playerSyndicateData: playerSyndicateData,
    title: "Medlem g\xE5r med i lag"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.MEMBER_REMOVED,
    onChange: handleSyndicateCbx,
    playerSyndicateData: playerSyndicateData,
    title: "Medlem l\xE4mnar lag"
  })))), React.createElement("div", {
    className: "padding-top"
  }, React.createElement(Section, {
    title: "F\xF6r dig som \xF6ppnar upp spel"
  }, React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.SHARE_PURCHASED,
    onChange: handleSyndicateCbx,
    playerSyndicateData: playerSyndicateData,
    title: "Medlem k\xF6per andel"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.BUYIN_CLOSED,
    onChange: handleSyndicateCbx,
    playerSyndicateData: playerSyndicateData,
    title: "Sista tid f\xF6r k\xF6p av andel passerar"
  })))), React.createElement("div", {
    className: "padding-top"
  }, React.createElement(Section, {
    title: "Butiksandelar"
  }, React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.NOTIFY_PARTICIPANTS,
    onChange: handleSyndicateCbx,
    playerSyndicateData: playerSyndicateData,
    title: "Meddelanden fr\xE5n butiken om spel du har k\xF6pt andelar i"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem
  , {
    id: syndicateMailId.NOTIFY_GROUPMEMBER,
    onChange: handleSyndicateCbx,
    playerSyndicateData: playerSyndicateData,
    title: "Allm\xE4nna meddelanden fr\xE5n butiken som du f\xF6ljer"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.MARKETPLACE_WAGER,
    onChange: handleSyndicateCbx,
    playerSyndicateData: playerSyndicateData,
    title: "Ett spel som du har andel i l\xE4mnas in"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.MARKETPLACE_REFUND,
    onChange: handleSyndicateCbx,
    playerSyndicateData: playerSyndicateData,
    title: "Ett spel som du har andel i blir \xE5terbetalt"
  })))))))));
};
svs.myProfile.react.pages.notifications.Notifications = Notifications;

 })(window);